import * as React from "react";
import styleable  from "react-styleable";
import * as styles from '../../../css/components/mainlayout/portalselect.css';

export class PortalSelectItem extends React.Component<any, any, any> {

    render() {
        var selectedClass = "";
        if(this.props.selected === true){
            selectedClass = this.props.css.portalSelectItemSelected;
        }
        return (
        <div className={this.props.css.portalSelectItem + " " + selectedClass} onClick={() => this.props.onSelectionChange(this)}>
            <p>{this.props.children}</p>
        </div>
    );
    }
}
export default styleable(styles)(PortalSelectItem);